const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3090';

const api = (path, options = {}) =>
  fetch(`${API_URL}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  }).then(async (res) => {
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.message || `HTTP ${res.status}`);
    }
    const text = await res.text();
    return text ? JSON.parse(text) : null;
  });

export const getProfile = (userId) => api(`/users/${userId}`);

export const updateProfile = (userId, data) =>
  api(`/users/${userId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });

// ---- Phones ----

export const createPhone = (userId, data) =>
  api(`/users/${userId}/phones`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const updatePhone = (userId, phoneId, data) =>
  api(`/users/${userId}/phones/${phoneId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const deletePhone = (userId, phoneId) =>
  api(`/users/${userId}/phones/${phoneId}`, { method: 'DELETE' });

// ---- Messengers ----

export const createMessenger = (userId, phoneId, data) =>
  api(`/users/${userId}/phones/${phoneId}/messengers`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const deleteMessenger = (userId, phoneId, messengerId) =>
  api(`/users/${userId}/phones/${phoneId}/messengers/${messengerId}`, {
    method: 'DELETE',
  });

// ---- Avatar ----

export const uploadAvatar = async (userId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API_URL}/users/${userId}/avatar`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const deleteAvatar = async (userId) => {
  const res = await fetch(`${API_URL}/users/${userId}/avatar`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `HTTP ${res.status}`);
  }
  return res.json();
};
